@if (loading) {
	<nz-spin nzSimple nzSize="large"></nz-spin>
}

<div>
	@switch (state) {
		@case (GenerateEmailUsersPageState.SUBMIT_EMAILS) {
			<app-emails-form (onSubmit)="onSubmitEmails$($event)"></app-emails-form>
		}
		@case (GenerateEmailUsersPageState.REVIEW_EXISTING_USERS) {
			<app-review-users-sections-table
				[emails]="emails"
				(onFinished)="showCreateNewUsers()"
			></app-review-users-sections-table>
		}
		@case (GenerateEmailUsersPageState.CREATE_EMAIL_USERS) {
			<app-generate-emails-users-form
				[emails]="emails"
				(onSubmit)="showFinished()"
			></app-generate-emails-users-form>
		}
		@case (GenerateEmailUsersPageState.FINISHED) {
			<h1>All finished.</h1>
		}
	}
</div>
